// @flow

import styled from 'styled-components';
import { ErrorLabel as BaseErrorLabel } from '../../../../../commons/molecules/error-label';

export const ErrorLabel = styled(BaseErrorLabel)`
  margin-top: 0.3rem;
`;
